import * as React from "react";
import { AppContextValue } from "./context-value";
import { AppContextValueImpl } from "./context-value-api-impl";

export const AppContext = React.createContext<AppContextValue>(
    new AppContextValueImpl()
);
